import z from 'zod';

// todo BUILD-3979 - finalize this schema
export const snippetVersionSchema = z.object({
  data: z.object({
    actions: z.record(z.any()),
    thresholds: z.record(z.any()),
    dataRoutes: z.record(z.any()),
  }),
  props: z.object({
    tags: z.array(z.any()),
    outcomes: z.array(z.any()),
    services: z.array(z.any()),
    publishedAttributes: z.array(z.any()),
    reasonCodeGroups: z.array(z.any()),
  }),
  metadata: z.record(z.any()).nullable().optional(),
});
